import React from "react";
import DgTransitionComponent from "./DgTransitionComponent";

const DgOverview = () => {
    return (
        <DgTransitionComponent dgoverview={true} />
    )
}

export default DgOverview;